import React from "react";
import { Table } from "reactstrap";

const CartStudentList = (props) => {
  let studentList = props.addedStudentList.map((p, i) => (
    <tr key={i}>
      <td className="ps-0">{p.name}</td>
      <td className="ps-0">{p.class.name}</td>
    </tr>
  ));

  return (
    <Table responsive>
      <thead>
        <tr>
          <th className="ps-0" style={{ borderTop: "none" }}>
            Namn
          </th>
          <th className="ps-0" style={{ borderTop: "none" }}>
            Klass
          </th>
        </tr>
      </thead>
      <tbody>{studentList}</tbody>
    </Table>
  );
};

export default CartStudentList;
